<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>音视频课程管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/backMusicList')">背景音乐列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='音乐标题'>
            <el-input
              style="width:200px"
              v-model="filters.keywords"
              placeholder="请输入标题搜索"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>

            <el-button v-if="hasPower('90015991')"
              type="primary"
              @click="addPostDialog"
            >新增</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="title"
            label="标题"
          >
          </el-table-column>

          <el-table-column
            prop="score"
            label="音频"
          >
            <template slot-scope="scope">
              <audio
                style="width:320px"
                v-if="scope.row.backUrl1.url != null"
                :src="scope.row.backUrl1.url"
                controls="controls"
              >
                浏览器不支持
              </audio>
            </template>
          </el-table-column>

          <el-table-column
            prop="createTime1"
            label="创建时间"
          >
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template>
                <el-button v-if="hasPower('90015991')"
                  @click="upHouseStatus(scope.row)"
                  type="text"
                  size="small"
                >删除</el-button>
              </template>

            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="新增背景音乐"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="标题"
          prop='title'
        >
          <el-input v-model="form.title"></el-input>
        </el-form-item>

        <el-form-item
          label="音频"
          prop="url"
        >
          <el-upload
            class="avatar-uploader"
            action="/manager/user/seven_app_file_up"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :data='tokenData'
          >
            <el-button
              size="small"
              type="primary"
              :loading='upLoading'
            >点击上传</el-button>

            <audio
              style="width:320px"
              v-if="form.url != null"
              :src="form.url.url"
              controls="controls"
            >
              浏览器不支持
            </audio>

          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >新增</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import { dateFunc } from "../../dateFunc";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "judgeList",
  created() {},
  data() {
    return {
      tokenData: {
        token: localStorage.getItem("api_token"),
        video:1
      },
      addFormRule: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        url: [{ required: true, message: "请上传音频 ", trigger: "blur" }],
      },
      filters: {
        keywords: null,
      },
      form: {
        url: null,
        title: null,
      },
      upLoading:false,
      addLoading: false,
      dialogAddVisible: false,
      loading: false,
      page_num: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight: null,
      audioDuration:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    beforeAvatarUpload(file) {
      this.upLoading = true;
      // 文件类型进行判断
      const isAudio = file.type === "audio/mp3" || file.type === "audio/mpeg";
      // 限制上传文件大小 2M
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isTime60S = this.audioDuration >= 60 ? true : "";
      // 获取时长
      this.getTimes(file);
      if (!isAudio) {
        this.upLoading = false;
        this.$message.error("上传文件只能是Mp3格式!");
        this.fileList = [];
      } else {
        // if (!isLt2M) {
        //   this.$message.error("上传文件大小不能超过 2MB!");
        //   this.fileList = [];
        // } else {
        //   if (!isTime60S) {
        //     this.$message.error("上传文件时长不能超过60秒!");
        //     this.fileList = [];
        //   }
        // }
      }
      // return isAudio && isLt2M && isTime60S;
      return isAudio;
    },
    getTimes(file) {
      var content = file;
      //获取录音时长
      var url = URL.createObjectURL(content);
      //经测试，发现audio也可获取视频的时长
      var audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", (_event) => {
        this.audioDuration = parseInt(audioElement.duration);
        // console.log(this.audioDuration);
      });
    },
    handleAvatarSuccess: function (e) {
      this.upLoading = false;
      if (e.key == 1000) {
        this.form.url = {
          url:e.result.map.path,
          time:this.audioDuration
        };
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500,
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    addPostDialog() {
      this.form.url = null;
      this.form.title = null;
      this.dialogAddVisible = true;
    },
    addPost() {
      let that = this;
      that.$refs["form"].validate((valid) => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          para.url = JSON.stringify(para.url);
          API.add_back_music(para)
            .then(
              function (result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500,
                  });
                  that.dialogAddVisible = false;
                  that.addLoading = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000,
                  });
                }
              },
              function (err) {
                that.dialogAddVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        }
      });
    },

    upHouseStatus(row) {
      let that = this;
      this.$confirm("确定删除该音频吗", "删除成功后，app和后台都不显示该音频", {
        type: 'success',
      })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
          };
          API.del_back_music(para)
            .then(
              function (result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {

                  that.$message.success({
                    showClose: true,
                    message: '删除成功',
                    duration: 1500,
                  });
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                }
              },
              function (err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    search() {
      let that = this;
      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token"),
      };
      if (that.filters.reco_type) {
        params.reco_type = that.filters.reco_type;
      }
      if (that.filters.keywords) {
        params.keywords = that.filters.keywords;
      }
      that.loading = true;
      API.back_music_list(params)
        .then(
          function (result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].backUrl1 = JSON.parse(
                    result.result.list[i].backUrl
                  );
                  result.result.list[i].createTime1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].createTime)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableData = result.result.list;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
  },
};
</script>

<style>
.shop-pic {
  width: 100%;
  /* display: flex;
    flex-wrap: wrap;
    justify-content: space-around; */
  height: 80vh;
  overflow: hidden;
  overflow-y: auto;
}
.shop-pic img {
  /* width: 49%; */
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/backMusicList.vue